import React, { useState } from 'react';
import { Container, TextField, Button, Tooltip, Modal, Box, Grid, AppBar, Toolbar, Paper, Typography } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AddClassType() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  let navigate = useNavigate();
  const [newClassType, setNewClassType] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success'); // 'success' or 'error'
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);


  const handleCancel = () => {
    setNewClassType("")
  }
  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/ClassType`;
      setLoadingBarProgress(30);
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          classType: newClassType,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setLoadingBarProgress(100);

        // detect failure either via status field or common error keywords in message
        const errorKeywords = ['already exist', 'failed', 'error', 'unable', 'cannot'];
        const messageHasError = errorKeywords.some(k => responseData.msg && responseData.msg.toLowerCase().includes(k));

        if (responseData.status && responseData.status.toLowerCase().includes('failed')) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else if (messageHasError) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else {
          setModalType('success');
          setModalMessage(responseData.msg || 'Class Type has been Added Successfully.');
        }

        setModalOpen(true);
        if (!messageHasError && (!responseData.status || !responseData.status.toLowerCase().includes('failed'))) {
          setNewClassType('');
        }
      } else {
        setLoadingBarProgress(0);
        // alert('Failed to save class type');
        setSnackbarMessage('Failed to save class type!');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      // alert('API request error:', error);
      setSnackbarMessage('API request error:', error);
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  return (
    <Container mt={4}>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add Class Type
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
        <div>
          <TextField
            label="Class Type"
            variant="outlined"
            fullWidth
            value={newClassType}
            onChange={(e) => setNewClassType(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!newClassType && "Enter Class Type"} arrow>
            <span><Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              sx={{ mr: 2 }}
              disabled={!newClassType}
            >
              SAVE
            </Button></span></Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: modalType === 'success' ? '#0B1F40' : '#d32f2f', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'success' ? 'Success ✅' : 'Error ❌'}
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage}
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType === 'success') {
                    navigate(-1); // go back after closing modal
                  }
                }}
                variant="contained"
                color={modalType === 'success' ? 'primary' : 'error'}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

    </Container>
  );
}

export default AddClassType;
